import React, { useContext } from "react";
import { LayersControl, WMSTileLayer } from "react-leaflet";
import { isEmpty } from "lodash";
import { getLayerLabel } from "../../actions/spectrumActions";
import LocaleContext from "constants/localization";
import { url } from "../../map/params";
import { finCRS } from "../../map/finCRS";
import WFSBuildingsLayer from "components/common/WFSBuildingsLayer";

/**
 * This component implements selectable map layers, used by all map components
 */
export default function MapLayersComponent(props) {
  const { wfsEnabled, layerConfig } = props;
  const LS = useContext(LocaleContext);

  const getWMSLayer = (layerDetails, baseMap) => {
    let attribution;
    if (baseMap) {
      attribution = LS.map.attribution + " " + getMonthYear();
    } else {
      attribution = "";
    }
    const styles = layerDetails.style ? layerDetails.style : "";
    const transparent = baseMap ? false : true;
    return (
      <WMSTileLayer
        url={url}
        attribution={attribution}
        noWrap={true}
        params={{
          service: "WMS",
          version: "1.3.0",
          request: "GetMap",
          layers: layerDetails.id,
          format: layerDetails.imageFormat,
          transparent: transparent,
          styles: styles,
          crs: finCRS,
          tileSize: 512,
          maxZoom: 12,
          providerId: layerDetails.provider,
          infoFormat: layerDetails.infoFormat,
        }}
      />
    );
  };

  /**
   * Gets current month and year to print in the map attribution, required by Maanmittauslaitos
   */
  const getMonthYear = () => {
    const today = new Date();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const year = today.getFullYear();
    return "(" + month + "/" + year + ")";
  };

  if (isEmpty(layerConfig)) {
    console.error(
      "No map layer configuration present. Map layers cannot be displayed"
    );
    return null;
  }

  return (
    <LayersControl position="topright">
      {layerConfig.baseMapDetails.map((v, i) => {
        if (layerConfig.defaultBaseMap === v.id) {
          return (
            <LayersControl.BaseLayer
              checked
              name={getLayerLabel(v, LS.getLanguage())}
              key={i}
            >
              {getWMSLayer(v, true)}
            </LayersControl.BaseLayer>
          );
        } else {
          return (
            <LayersControl.BaseLayer
              name={getLayerLabel(v, LS.getLanguage())}
              key={i}
            >
              {getWMSLayer(v, true)}
            </LayersControl.BaseLayer>
          );
        }
      })}
      {layerConfig.overlayMapDetails.map((v, i) => {
        if (v.type && v.type === "wfs") {
          if (wfsEnabled) {
            return <WFSBuildingsLayer layerDetail={v} key={i} />;
          } else {
            return null;
          }
        } else {
          return (
            <LayersControl.Overlay
              name={getLayerLabel(v, LS.getLanguage())}
              key={i}
            >
              {getWMSLayer(v, false)}
            </LayersControl.Overlay>
          );
        }
      })}
    </LayersControl>
  );
}
